import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MenuContentMixin } from '../../mixins/components/MenuContentMixin';

/**
 * The `Menu` component is usually limited to a list of `MenuItem` actions, but you can add brief
 * supporting text with this component.
 *
 * @since 7.28.0
 */
var MenuContent = /*#__PURE__*/styled.p.withConfig({
  displayName: "MenuContent",
  componentId: "c11n-8-111-1__sc-1zffre-0"
})(["", ""], MenuContentMixin);
MenuContent.displayName = 'MenuContent';
MenuContent.propTypes = {
  /**
   * Supporting menu text.
   */
  children: PropTypes.node.isRequired
};

/** @component */
export { MenuContent };